"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<a6a9c16eab8066166af59db96df1f731>>
 *
 * Generated by CLDRGenScript
 *
 * 
 */
var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType18 = {
  getVariation: function getVariation(n) {
    if (n === 0 || n === 1) {
      return IntlVariations.NUMBER_ONE;
    } else if (n >= 2 && n <= 10) {
      return IntlVariations.NUMBER_FEW;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType18;